"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35.4 16",
    width: "35.4",
    height: "16"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M34.9,12.7h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S35.2,12.7,34.9,12.7z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M2.9,12.7h-2c-0.3,0-0.5-0.2-0.5-0.5s0.2-0.5,0.5-0.5h2c0.3,0,0.5,0.2,0.5,0.5S3.2,12.7,2.9,12.7z"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "12.3",
    y: "11.7",
    fill: "#9ECE06",
    width: "10.7",
    height: "1.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M23,13.9H12.3c-0.3,0-0.5-0.2-0.5-0.5v-1.6c0-0.3,0.2-0.5,0.5-0.5H23c0.3,0,0.5,0.2,0.5,0.5v1.6 C23.5,13.6,23.3,13.9,23,13.9z M12.8,12.9h9.7v-0.6h-9.7V12.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M9,16c-1.4,0-2.5-1.1-2.5-2.5S7.6,11,9,11s2.5,1.1,2.5,2.5S10.4,16,9,16z M9,12c-0.8,0-1.5,0.7-1.5,1.5 S8.2,15,9,15s1.5-0.7,1.5-1.5S9.8,12,9,12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M4.6,16c-1.4,0-2.5-1.1-2.5-2.5S3.2,11,4.6,11s2.5,1.1,2.5,2.5S5.9,16,4.6,16z M4.6,12 c-0.8,0-1.5,0.7-1.5,1.5S3.7,15,4.6,15s1.5-0.7,1.5-1.5S5.4,12,4.6,12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M30.8,16c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5S32.2,16,30.8,16z M30.8,12 c-0.8,0-1.5,0.7-1.5,1.5S30,15,30.8,15s1.5-0.7,1.5-1.5S31.6,12,30.8,12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M26.4,16c-1.4,0-2.5-1.1-2.5-2.5S25,11,26.4,11s2.5,1.1,2.5,2.5S27.7,16,26.4,16z M26.4,12 c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5s1.5-0.7,1.5-1.5S27.2,12,26.4,12z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M29.8,11.9H5.5c-3,0-5.5-2.5-5.5-5.5c0-3,2.5-5.5,5.5-5.5h24.3c3,0,5.5,2.5,5.5,5.5 C35.3,9.4,32.8,11.9,29.8,11.9z M5.5,1.9C3,1.9,1,3.9,1,6.4c0,2.5,2,4.5,4.5,4.5h24.3c2.5,0,4.5-2,4.5-4.5c0-2.5-2-4.5-4.5-4.5 H5.5z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M10.7,1.9H7.8c-0.3,0-0.5-0.2-0.5-0.5V0.5C7.3,0.2,7.5,0,7.8,0h2.9c0.3,0,0.5,0.2,0.5,0.5v0.9 C11.2,1.7,11,1.9,10.7,1.9z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#9ECE06",
    d: "M26.8,1.9h-2.9c-0.3,0-0.5-0.2-0.5-0.5V0.5c0-0.3,0.2-0.5,0.5-0.5h2.9c0.3,0,0.5,0.2,0.5,0.5v0.9 C27.3,1.7,27,1.9,26.8,1.9z"
  }), /*#__PURE__*/_react["default"].createElement("circle", {
    fill: "#9ECE06",
    cx: "17.9",
    cy: "6.5",
    r: "2.7"
  }));
};

exports["default"] = _default;